module.exports = __webpack_public_path__ + "static/media/popup_character.ca3ee5cb.svg";